<template>
  <fragment>
    <search-nav-year-month label="대상연월" :value="{ year: '', month: '' }" @input="changeYM" />
    <search-nav-item-select :label="$t('search.검색조건')" v-model="nav.searchType" :list="searchTypes" />
    <search-nav-item-keyword :label="$t('search.키워드')" v-model="nav.searchKeyword" />
  </fragment>
</template>

<script>
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import SearchNav from "@/components/nav/SearchNav";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
import moment from "moment";

export default {
  name: "NormalSearchNav365",
  components: {
    SearchNavYearMonth,
    SearchNavStartEnd,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    SearchNav,
  },
  watch: {
    nav: {
      immediate: true,
      deep: true,
      handler() {
        this.$emit("input", this.nav);
      },
    },
  },
  data() {
    return {
      nav: {
        created_at: {},

        searchType: "",
        searchKeyword: "",
      },
      searchTypes: [{ value: "회사명" },   { value: "작성자" }],
    };
  },
  methods: {
    changeYM(value) {
      if (!value.year) {
        this.nav.created_at = {
          sDate: ``,
          eDate: ``,
        };
        return;
      } else if (!value.month) {
        this.nav.created_at = {
          sDate: `${value.year}-01-01`,
          eDate: `${value.year}-12-31`,
        };
        return;
      } else {
        this.nav.created_at = {
          sDate: moment(`${value.year}-${value.month}`).format("YYYY-MM-01"),
          eDate: moment(`${value.year}-${value.month}`).format("YYYY-MM-30"),
        };
      }
    },
  },
};
</script>

<style scoped></style>
